import { Delete, Edit, OpenInNew } from "@mui/icons-material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { Box, IconButton, Typography, Tooltip } from "@mui/material";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import local from "dayjs/plugin/localizedFormat";
import { I18n } from "aws-amplify/utils";
dayjs.extend(utc);
dayjs.extend(local);

const columns = (setSelectedUser, setPermissionOpen, userInfo) => [
  { 
    field: "user_id", 
    headerName: I18n.get("User ID"),
      flex:1
  },
  {
    field: "user_email",
    headerName: I18n.get("Email"),
    flex:1,
    renderCell: (params) => (
      <Typography
        component="a"
        href={`mailto:${params.value}`}
        sx={{
          fontSize: "medium",
          cursor: "pointer",
          textDecoration: "underline",
        }}
      >
        {params.value}
      </Typography>
    ),
  },
  { 
    field: "user_name", 
    headerName: I18n.get("Name"), 
    flex:1 
  },
  { 
    field: "user_profile", 
    headerName: I18n.get("Profile"), 
    flex:1
  },
  {
    field: "hr_app_registration_date",
    headerName: I18n.get("Registration Date"),
    flex:1,

    valueFormatter: (value) => {
      if (!value) {
        return ""; // Handle null or undefined values
      }
      const formattedDate = dayjs
        .utc(value)
        .local()
        .format("YYYY-MM-DD HH:mm:ss");
      return formattedDate;
    },
  },
  {
    field: "actions",
    headerName: I18n.get("Actions"),
    width: 80,
    sortable: false,
    filterable: false,
    renderCell: (params) => {
      const isPermissionButtonDisabled =
        params.row.user_profile === "SuperAdmin";
      // const isPermissionEditProfile =
      //   groupNameSel === "Admin" && isPermissionButtonDisabled;

      // Disable edit permission button if it's current user
      const isCurrentUser = params.row.user_email === userInfo.email;

      return (
        <Box textAlign={"center"}>
          {/* <Tooltip title={I18n.get("Edit Profile")}>
            <IconButton
              aria-label="edit"
              onClick={() => {
                setSelectedUser(params.row);
                setEditUserOpen(true);
              }}
              disabled={isPermissionEditProfile || isCurrentUser} // Condizione aggiunta
            >
              <ManageAccountsIcon />
            </IconButton>
          </Tooltip> */}
          <Tooltip title={I18n.get("Edit Permission")} >
            <IconButton
              aria-label="edit"
              onClick={() => {
                if (!isPermissionButtonDisabled) {
                  setSelectedUser(params.row);
                  setPermissionOpen(true);
                }
              }}
              disabled={isPermissionButtonDisabled || isCurrentUser} // Disable edit permission button if it's current user or SuperAdmin
            >
              <VisibilityIcon />
            </IconButton>
          </Tooltip>
        </Box>
      );
    },
  },
];
export default columns;
